import { useEffect } from "react";

type Options = {
  onConnect: (gamepad: Gamepad) => void;
};

export function useGamepadConnect({ onConnect }: Options) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleConnect = (e: GamepadEvent) => {
      onConnect(e.gamepad);
    };

    window.addEventListener("gamepadconnected", handleConnect);

    return () => {
      window.removeEventListener("gamepadconnected", handleConnect);
    };
  }, [onConnect]);
}